<template>
  <nav aria-label="Page navigation example">
    <ul class="flex -space-x-px text-base h-10">
      <li v-for="(page, i) in visiblePages" :key="i">
        <button
          @click="$emit('pageClick', page.id)"
          class="ripple flex items-center justify-center px-4 h-10 border border-gray-300"
          :class="{
            'rounded-l-xl border-r-0': i == 0,
            'rounded-r-xl border-l-0': i == visiblePages.length - 1,
            'title-color bg-primary-200': page.id == currentPage,
          }"
        >
          {{ page.name }}
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PaginationNaviation',
  components: {},
  props: {
    currentPage: {
      type: Number,
      default() {
        return 1
      },
    },
    totalPages: {
      type: Number,
      default() {
        return 1
      },
    },
  },
  data() {
    return {}
  },
  mounted() {},
  beforeUnmount() {},
  methods: {},
  computed: {
    visiblePages() {
      let visiblePages = [
        { name: 'Précédent', id: this.currentPage - 1 },
        { name: `${this.currentPage - 3}`, id: this.currentPage - 3 },
        { name: `${this.currentPage - 2}`, id: this.currentPage - 2 },
        { name: `${this.currentPage - 1}`, id: this.currentPage - 1 },
        { name: `${this.currentPage}`, id: this.currentPage },
        { name: `${this.currentPage + 1}`, id: this.currentPage + 1 },
        { name: `${this.currentPage + 2}`, id: this.currentPage + 2 },
        { name: `${this.currentPage + 3}`, id: this.currentPage + 3 },
        { name: 'Suivant', id: this.currentPage + 1 },
      ].filter(page => page.id > 0 && page.id <= this.totalPages)
      if (visiblePages.length == 1) visiblePages = []
      return visiblePages
    },
  },
})
</script>
